var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.tags),function(tag){return _c('TagWidget',{key:tag.pk,attrs:{"tag":tag,"object-id":_vm.objectId,"object-type":_vm.objectType},on:{"tag-del":_vm.fetchTags}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }